import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import React from "react"
import Route from "@kaspernj/api-maker/build/router/route"
import Switch from "@kaspernj/api-maker/build/router/switch"
import {useWoofRouter} from "shared/woof-router"
/** @typedef {object} RoutesAdminSurveyStepElementOptionScoresRouteProps */

/** @typedef {object} RoutesAdminSurveyStepElementOptionScoresRouteState */

/**
 * @extends {ShapeComponent<RoutesAdminSurveyStepElementOptionScoresRouteProps, RoutesAdminSurveyStepElementOptionScoresRouteState>}
 */
class RoutesAdminSurveyStepElementOptionScoresRoute extends ShapeComponent {
  setup() {
    this.woofRouter = useWoofRouter()
  }

  render() {
    return (
      <Switch name="survey-step-element-option-scores">
        <Route component="edit" exact path="new" />
        <Route component="preview" exact path=":survey_step_element_option_score_id/preview" />
        <Route exact path=":survey_step_element_option_score_id/edit" />
        <Route component="show" exact path=":survey_step_element_option_score_id" />
        <Route componentPath="fallback" fallback onMatch={this.tt.onFallbackMatch} />
      </Switch>
    )
  }

  onFallbackMatch = () => this.woofRouter.setPageNotFound(true)
}

export default memo(shapeComponent(RoutesAdminSurveyStepElementOptionScoresRoute))
